import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { AnyAction, Dispatch } from 'redux';
import { H3, Text } from '@shared/ui-components';

import { CrashDialog } from 'common/components/crash-dialog';
import { PageHeader } from 'common/components/page-header';
import { SubscriptionType } from 'common/constants/subscription';
import { State } from 'common/interfaces/state';
import { AccountSelectors } from 'unit-account/selectors';
import { PaymentSourcesModel } from 'unit-subscription/interfaces/payment-sources-model';
import { AppUrls } from '../../../../routes/app-urls';
import { SubscriptionActions } from '../../actions/creators';
import { SubscriptionEditor } from '../../components/subscription-dialog/subscription-editor';
import { Styled } from './styled';


interface StateProps {
  subscriptionType: SubscriptionType;
  paymentSource: PaymentSourcesModel;
  isUserLimitExceeded: boolean;
}

interface DispatchProps {
  getOwnCompanyBillingInfo: (subscriptionType: SubscriptionType) => void;
  dropOwnCompanyBillingInfoState: () => void;
}

interface PageProps extends StateProps, DispatchProps, RouteComponentProps<{}> { }

class RenewSubscriptionPageComponent extends React.Component<PageProps> {
  public componentDidMount(): void {
    this.props.getOwnCompanyBillingInfo(this.props.subscriptionType);
  }

  public render(): React.ReactNode {
    return (
      <Styled.Container>
        <Styled.Header>
          <PageHeader
            redirectUrl={AppUrls.products.path}
          />
        </Styled.Header>
        <Styled.Main>
          <Styled.NoteContainer>
            <Text fontSize={30}>
              Your subscription was cancelled.
            </Text>
            <Text fontSize={30}>
              {this.getNoteText()}
            </Text>
          </Styled.NoteContainer>
          {
            this.props.isUserLimitExceeded && (
              <H3>You need to update your subscription or contact with support.</H3>
            )
          }
          <SubscriptionEditor mode='renew' />
        </Styled.Main>
        <CrashDialog />
      </Styled.Container>
    );
  }

  public componentWillUnmount(): void {
    this.props.dropOwnCompanyBillingInfoState();
  }

  private getNoteText(): string {
    if (!this.props.paymentSource) {
      return null;
    }

    return this.props.paymentSource.primaryCardId
      ? 'You can renew the subscription.'
      : 'Add payment method to renew the subscription.';
  }
}

function mapStateToProps(state: State): StateProps {
  return {
    subscriptionType: state.account.selectedSubscriptionType,
    paymentSource: state.account.payment,
    isUserLimitExceeded: AccountSelectors.isSelectedCompanyLicensesLimitExceeded(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>): DispatchProps {
  return {
    getOwnCompanyBillingInfo: type => dispatch(SubscriptionActions.fetchOwnCompanyBillingInfo(type)),
    dropOwnCompanyBillingInfoState: () => dispatch(SubscriptionActions.dropOwnCompanyBillingInfoState()),
  };
}

export const RenewSubscriptionPage = connect(mapStateToProps, mapDispatchToProps)(RenewSubscriptionPageComponent);
